import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import cs from 'classnames'

import Button from '../Button'

import CheckDarkGreen from 'assets/svg/check_darkgreen.svg'
import Edit from 'assets/svg/edit.svg'

import { TagPushCarousel } from 'analytics/carousel'

import { useMobile } from 'utils/mobile'
import * as promotionTypes from 'constants/product-promotion-types'

import './ProductCard.scss'
import LinkButton from '../LinkButton'

const ButtonAction = ({ link, base, flip, name, url, mobile, bank }) => {
    if (!link) {
        return (
            <LinkButton
                onClick={() => {
                    TagPushCarousel.interactionProductLink(
                        'link',
                        bank,
                        'saiba mais',
                        name
                    )
                }}
                path={url}
            >
                Saiba mais
            </LinkButton>
        )
    }

    if (link && !base) {
        return (
            <a
                className="product-card--actions--know-more-link"
                href={link}
                onClick={() => {
                    TagPushCarousel.interactionProductLink(
                        'link',
                        bank,
                        'saiba mais',
                        name
                    )
                }}
                target="_blank"
                rel="noopener noreferrer"
            >
                Saiba mais
            </a>
        )
    }

    return (
        <button
            className="product-card--actions--know-more-btn"
            type="button"
            onClick={() => {
                TagPushCarousel.interactionProductLink(
                    'link',
                    bank,
                    'saiba mais',
                    name
                )
                if (mobile) {
                    flip()
                }
            }}
        >
            Saiba mais
        </button>
    )
}

const ProductCard = ({
    id,
    code,
    background,
    card,
    name,
    customName,
    url,
    base,
    link,
    description,
    bank,
    promotion,
    children,
    flipped,
    hidden,
    purchased,
    minValue,
    maxValue,
    onFlip,
    onAdd
}) => {
    const [hiddenFront, setHiddenFront] = useState(!!flipped)
    const [hiddenBack, setHiddenBack] = useState(!flipped)

    const flip = () => {
        onFlip(true)
    }

    const backFlip = () => {
        TagPushCarousel.interactionProductClose(bank, name)
        onFlip(false)
    }

    const addProduct = (values, props) => {
        onAdd(values, props)
    }

    const editCart = () => {
        TagPushCarousel.interactionProductButton(
            'button',
            bank,
            'editar cesta',
            name
        )
        if (mobile) {
            flip()
        }
    }

    const getPromotion = (promo) => {
        if (promo === promotionTypes.ZERO_TAX) {
            return <div className="product-card__tag">taxa zero</div>
        }

        return null
    }

    const isInitialMount = useRef(true)
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false
            return
        }

        setTimeout(() => {
            if (flipped) {
                setHiddenFront(true)
                setHiddenBack(false)
            } else {
                setHiddenFront(false)
                setHiddenBack(true)
            }
        }, 250)
    }, [flipped])

    const mobile = useMobile()

    const getUrl = () => {
        if (url) {
            if (base) {
                return `/${base}/detalhes/${url}`
            } else {
                return `/detalhes/${url}`
            }
        }

        if (link && !base) {
            return link
        }

        return null
    }

    return (
        <div className="container">
            <div
                className={cs('product-card', {
                    'product-card--hidden': hidden,
                    'product-card--purchased': purchased
                })}
            >
                <div
                    className={cs('product-card__wrap', {
                        'product-card--flipped': flipped
                    })}
                >
                    {!hiddenFront && (
                        <div
                            id={`productCardFront${id}`}
                            className="product-card__side product-card--front"
                            onClick={() => {
                                if (!mobile) {
                                    flip()
                                }
                            }}
                        >
                            {getPromotion(promotion)}
                            <header
                                className="product-card--front__header"
                                style={{
                                    backgroundSize: 'cover',
                                    backgroundImage: `url(${background})`
                                }}
                            >
                                <a
                                    className="product-card--front__link"
                                    href={getUrl()}
                                    target={link && !base && '_blank'}
                                    rel={link && !base && 'noopener noreferrer'}
                                >
                                    <div
                                        className="wrapper-image"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (link && base) {
                                                flip()
                                            }
                                        }}
                                    >
                                        <div
                                            className={cs(
                                                'overlay',
                                                id.toLowerCase()
                                            )}
                                        >
                                            <div className="overlay__text">
                                                Saiba Mais
                                            </div>
                                        </div>
                                        <img
                                            id={`seeInternalProduct${id}`}
                                            src={card}
                                            alt="Card"
                                        />
                                    </div>
                                </a>
                            </header>
                            <h2>
                                <a
                                    className="product-card--front__link"
                                    href={getUrl()}
                                    target={link && !base && '_blank'}
                                    rel={link && !base && 'noopener noreferrer'}
                                >
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            if (link && base) {
                                                flip()
                                            }
                                        }}
                                    >
                                        {customName ? customName : 'Alelo'}
                                        <strong> {name}</strong>
                                    </div>
                                </a>
                            </h2>
                            <p>{description}</p>
                            <div className="product-card--actions">
                                {purchased ? (
                                    <>
                                        <Button
                                            id="added"
                                            type="button"
                                            kind="added"
                                        >
                                            <img
                                                src={CheckDarkGreen}
                                                alt="Checked"
                                            />
                                            Adicionado à cesta
                                        </Button>
                                        <Button
                                            id="edit"
                                            type="button"
                                            kind="edit"
                                            onClick={editCart}
                                        >
                                            <img src={Edit} alt="Edit" />
                                            Editar cesta
                                        </Button>
                                    </>
                                ) : (
                                    <Button
                                        id={`buy${id}`}
                                        type="button"
                                        kind="basic"
                                        onClick={() => {
                                            TagPushCarousel.selectItem({
                                                code,
                                                name
                                            })
                                            TagPushCarousel.interactionProductButton(
                                                'button',
                                                bank,
                                                'eu quero',
                                                name
                                            )
                                            if (mobile) {
                                                flip()
                                            }
                                        }}
                                    >
                                        Eu quero!
                                    </Button>
                                )}
                                <div className="product-card--actions--know-more">
                                    <ButtonAction
                                        link={link}
                                        base={base}
                                        bank={bank}
                                        flip={flip}
                                        name={name}
                                        mobile={mobile}
                                        url={getUrl()}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {!hiddenBack && (
                        <div className="product-card__side product-card--back">
                            <header className="product-card--back__header">
                                <h2>
                                    {customName ? customName : 'Alelo'}
                                    <strong> {name}</strong>
                                </h2>
                                <img src={card} alt="Card" />
                            </header>
                            {children(
                                backFlip,
                                addProduct,
                                minValue,
                                maxValue,
                                id,
                                bank
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    bank: state.bank.name
})

ProductCard.propTypes = {
    promotion: PropTypes.number,
    background: PropTypes.string.isRequired,
    card: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    customName: PropTypes.string,
    description: PropTypes.string.isRequired
}

export default connect(mapStateToProps, null)(ProductCard)
